export default function SPSS_2026() {
    return (
        <>
            <div className="mt-10 p-5 desktop:p-6 rounded-2xl border border-contact bg-contact-bg">
                <div className="flex flex-col gap-4">
                    <div>
                        <h3 className="text-lg font-bold font-sans">CONTACT US</h3>
                        <p className="text-xs text-white/40 font-sans">Hubungi kami jika kamu memiliki pertanyaan</p>
                    </div>

                    <div className="flex flex-col desktop:flex-row gap-4">
                        {/* SMILE */}
                        <div className="flex-1 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-bold text-white/90 font-sans">SMILE</span>
                                <span className="w-px h-4 bg-white/20" />
                                <span className="text-sm text-white/50 font-sans">Kelvin Saputra</span>
                            </div>
                            <div className="flex gap-2">
                                <a href="https://wa.me/6289502857889" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-whatsapp text-white text-sm font-semibold font-sans no-underline hover-scale-btn hover-shadow-whatsapp">
                                    <i className="fa-brands fa-whatsapp text-sm" />
                                    WhatsApp
                                </a>
                                <a href="https://line.me/ti/p/~kelvinsap" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-line text-white text-sm font-semibold font-sans no-underline hover-scale-btn hover-shadow-line">
                                    <i className="fa-brands fa-line text-sm" />
                                    LINE
                                </a>
                            </div>
                        </div>

                        <div className="hidden desktop:block w-px bg-divider self-stretch" />

                        {/* GLANCE */}
                        <div className="flex-1 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-bold text-white/90 font-sans">GLANCE</span>
                                <span className="w-px h-4 bg-white/20" />
                                <span className="text-sm text-white/50 font-sans">Theodore Wiryo Pranoto</span>
                            </div>
                            <div className="flex gap-2">
                                <a href="https://wa.me/6282146842900" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-whatsapp text-white text-sm font-semibold font-sans no-underline hover-scale-btn hover-shadow-whatsapp">
                                    <i className="fa-brands fa-whatsapp text-sm" />
                                    WhatsApp
                                </a>
                                <a href="https://line.me/ti/p/~theodorewepe" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-line text-white text-sm font-semibold font-sans no-underline hover-scale-btn hover-shadow-line">
                                    <i className="fa-brands fa-line text-sm" />
                                    LINE
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr className="border-none border-t border-divider" />

                    {/* Official Channels */}
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
                        <a href="https://www.instagram.com/himstat.spss/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-brands fa-instagram text-base w-5 text-center" />
                            @himstat.spss
                        </a>
                        <a href="https://himstat.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-solid fa-globe text-base w-5 text-center" />
                            himstat.com
                        </a>
                        <a href="mailto:himstat@gmail.com" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-solid fa-envelope text-base w-5 text-center" />
                            himstat@gmail.com
                        </a>
                    </div>
                </div>
            </div>

            <div className="mt-5 p-6 desktop:p-8 rounded-2xl border border-card-border bg-card-bg">
                <h3 className="text-xl font-bold mb-3 font-sans">Pendaftaran SPSS 2026</h3>
                <p className="text-sm text-white/50 mb-5 font-sans leading-relaxed">
                    Ikuti Statistical Project for Smart Students dan tunjukkan kemampuanmu dalam kompetisi statistika!
                </p>

                <div className="flex items-start gap-3">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdwL83igiobMhaSzq86mDDqxzzSmuxDnL8aB6ctsM8z8GFYyg/viewform?usp=sharing&ouid=108977800256877187634" className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-white text-midnight text-sm font-bold font-sans no-underline hover-scale-btn hover-shadow-white">
                        Daftar Sekarang
                        <i className="fa-solid fa-arrow-right text-xs" />
                    </a>

                    <a href="https://drive.google.com/drive/folders/1RXU6x0n8N76sfRpOM148yV1D6cHTRUAI" className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-white text-midnight text-sm font-bold font-sans no-underline hover-scale-btn hover-shadow-white">
                        Guidebook SPSS 2026
                        <i className="fa-solid fa-arrow-right text-xs" />
                    </a>
                </div>
            </div>
        </>
    );
}
